import type {ReactElement, ReactNode} from 'react';
import React from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import type {ElementTestId} from '@Tests/tests.types';
import type {ActivityIndicatorProps} from '@Components/activity-indicator/activity-indicator.types';
import {ActivityIndicator} from '@Components/activity-indicator/activity-indicator';
import styles from './add-item-container.module.scss';

interface AddItemContainerProps {
  id: string;
  children?: ReactNode;
  onClick?(): void;
  className?: string;
  hasMarginBottom?: boolean;
  isDisabled?: boolean;
  isSelected?: boolean;
  'data-testid'?: ElementTestId;
  activityIndicatorProps?: ActivityIndicatorProps;
}

export function AddItemContainer({hasMarginBottom = true, ...props}: AddItemContainerProps): ReactElement {
  return (
    <ClickableDiv
      onClick={(): void => {
        if (props.onClick) {
          props.onClick();
        }
      }}
      data-testid={props['data-testid']}
      id={props.id}
      className={`${styles.baseContainer} ${styles.container} ${props.isDisabled ? styles.disabled : ''} ${hasMarginBottom ? 'spacing-m-b-3' : ''} hover-transition-all radius-4 ${props.className ?? ''} ${
        props.isSelected ? styles.selected : ''
      } flex-column-justify-center flex-items-center`}
    >
      {props.activityIndicatorProps ? (
        <ActivityIndicator {...props.activityIndicatorProps} className={`${props.activityIndicatorProps.className ?? ''} ${styles.activityIndicator}`} />
      ) : null}
      {props.children}
    </ClickableDiv>
  );
}
